import * as React from 'react';

import { Title, Address, Developer, Wrapper, TooltipLabel, Underground, ResidentialStatus, Status } from './parts';
import * as styles from './styles.css';
import { IBuilder, ILabel, IUnderground } from '../../types/newbuildingHeader';

interface INewbuildingHeaderInformationProps {
  title: string | null;
  url: string | null;
  address: string | null;
  status: string | null;
  residentialStatus?: string | null;
  underground: IUnderground | null;
  builder: IBuilder | null;
  labels: ILabel[] | null;
}

export const NewbuildingHeaderInformation: React.FC<INewbuildingHeaderInformationProps> = ({
  underground,
  builder,
  title,
  url,
  address,
  status,
  labels,
  residentialStatus,
}) => {
  return (
    <div className={styles['information']}>
      <Wrapper>{labels && labels.map(label => <TooltipLabel key={label.title} label={label} />)}</Wrapper>
      {title && url && <Title title={title} url={url} />}
      {address && <Address address={address} />}
      {underground && <Underground underground={underground} />}
      <div className={styles['infoRow']}>
        {builder && <Developer developer={builder} />}
        {status && <Status status={status} />}
        {residentialStatus && <ResidentialStatus status={residentialStatus} />}
      </div>
    </div>
  );
};
